import style from "../blog.module.css";
import ExpandableText from "../TextoExpandible";
import foto from "../../../assets/blog/Mayo-13-2026.jpg";


const Semana57: React.FC = () => {
  const Notice1 = `
  ➡️Hicimos control político a las secretarías de Seguridad y Justicia frente a la creciente ola de violencia que vive nuestra ciudad, exigiendo acciones reales y presencia institucional en los territorios.

✊ Iniciamos nuestra #AlianzaPorLaVida junto a Iván Cepeda y Aída Quilcué, construyendo una agenda basada en la paz, la justicia social y el cuidado de nuestros territorios.

🚲 Además, presentamos el proyecto de acuerdo Cali en Bici, una apuesta por la movilidad sostenible y la protección de la vida en las vías.

🌻El Cambio es con Vos.🌻 comparte con tus contactos 📲
Síguenos en nuestras redes sociales @rodrisalazarco y entérate de más.
`;

  return (
    <section className={style.Noticia}>
      <div className={style.FotoMediosMarzo2025}>
        <img
          className={style.FotoImgMedios}
          src={foto}
          alt="FotoResumen"
          draggable={false}
        />
      </div>
      <div className={style.Separador}></div>
      <div className={style.NoticeBox}>
        <h1 className={style.Tittle}>
          Llegó nuestra Gaceta Informativa de Abril 🤩🌻{" "}
        </h1>
        <h5 className={style.Fecha}>Mayo 13 del 2026</h5>
        <ExpandableText text={Notice1} limit={800} />
        <p className={style.reportero}>
          Oficina de Comunicaciones Concejal Rodrigo Salazar, Partido Alianza
          Verde 🌻{" "}
        </p>
      </div>
    </section>
  );
};

export default Semana57;
